<div class="container extra-space">
  <div class="step-indicator-container">
    <app-step-indicator [currentStep]="(currentStepIndicatorIndex$ | async) || 3" [thirdpartyDocumentsAemContent]="thirdpartyDocumentsAemContent"></app-step-indicator>
  </div>
  <p class="header-label">{{ labels.heading }}</p>
  <table id="brokerage-sortableTable" class="c11n-table c11n-table--small table-margin-top" [attr.aria-label]="labels.selectTypeForMutualFundsLabel" *ngIf="isBrokerageAccountSelected">
    <thead>
    <tr class="c11n-table__tr">
      <th id="brokarage-col-1-header-2" scope="col" class="c11n-table__thead-th table-header-label">
        {{ labels.brokerageHeading }}
      </th>
    </tr>
    </thead>
    <tbody>

    <tr class="c11n-table__tr table-row-no-highlight">
      <td scope="row" class="table-data">
        <c11n-radio-group class="brokerage-radio" [isDisabled]="false" [errorText]="labels.errorMessage" [hideLegend]="true" [legendText]="'Radio group'" [hasError]="hasError"
                          (stateChange)="radioGroupForBrokerageAccount($event)" [variant]="'default'" [hasCustomHintError]="false">
          <c11n-radio [focusLabel]="false" labelText="{{ labels.statementsOnly }}">
            <input c11nRadioInput type="radio" name="choices1" value="{{labels.statementsOnlyAltText}}" [defaultChecked]="existingBrokerageOptedFor === 'STATEMENTS'"/>
          </c11n-radio>
          <c11n-radio [focusLabel]="false" labelText="{{ labels.confirmationsOnly }}">
            <input c11nRadioInput type="radio" name="choices1" value="{{labels.confirmationsOnlyAltText}}" [defaultChecked]="existingBrokerageOptedFor === 'CONFIRMATIONS'"/>
          </c11n-radio>
          <c11n-radio [focusLabel]="false" labelText="{{ labels.statementsAndConfirmations }}">
            <input c11nRadioInput type="radio" name="choices1" value="{{labels.statementsAndConfirmationsAltText}}" [defaultChecked]="existingBrokerageOptedFor === 'STATEMENTS_CONFIRMATIONS'"/>
          </c11n-radio>
        </c11n-radio-group>

      </td>
    </tr>
    </tbody>
  </table>
  <table id="mutual-fund-sortableTable" class="c11n-table c11n-table--small table-margin-top" aria-label="labels.selectTypeForBrokerageLabel" *ngIf="isMutualFundSelected">
    <thead>
    <tr class="c11n-table__tr">
      <th  scope="col" class="c11n-table__thead-th table-header-label">
        {{ labels.mutualFundHeading }}
      </th>
    </tr>
    </thead>
    <tbody>

    <tr class="c11n-table__tr table-row-no-highlight">
      <td scope="row" class="table-data">
        <c11n-radio-group class="brokerage-radio" [isDisabled]="false" [errorText]="labels.errorMessage" [hideLegend]="true" [legendText]="'Radio group'" [hasError]="false"
                          [variant]="'default'" [hasCustomHintError]="false">
          <c11n-radio [focusLabel]="false" labelText="{{ labels.statementsAndConfirmations }}">
            <input c11nRadioInput id="radio3" type="radio" name="choices" value="labels.statementsAndConfirmationsAltText" [defaultChecked]="isMutualFundSelected"/>
          </c11n-radio>
        </c11n-radio-group>

      </td>
    </tr>
    </tbody>
  </table>

  <div class="row btn-container">
    <div class="col-4 col-lg-2 col-xl-2 ps-0 mb-3 mb-lg-0 btn-mobile margin-left-10">
      <c11n-button buttonType="button" [size]="'small'" variant="primary"
                   [labelText]="labels.continueButton" (clickEvent)="goToPage()"
                   iconName="" colorMode="on-light"></c11n-button>
    </div>
    <div class="col-4 col-lg-2 col-xl-2 ps-0 btn-mobile">
      <c11n-button buttonType="button" [size]="'small'" variant="secondary"
                   [labelText]="labels.cancelButton" (clickEvent)="goToPage('home')"
                   iconName="" colorMode="on-light"></c11n-button>
    </div>
  </div>
</div>
